<template>
  <div class="vs-views">
    <p class="with-vs">
      <sup class="with-vs-text">WITH VS</sup>
      {{ withVS | numberFormat('0,0') }}
    </p>
    <p class="without-vs">
      <sup class="without-vs-text">WITHOUT VS</sup>
      {{ (total - withVS) | numberFormat('0,0') }}
    </p>
  </div>
</template>

<script>
export default {
  props: {
    total: Number, // eslint-disable-line vue/require-default-prop
    withVS: Number // eslint-disable-line vue/require-default-prop
  }
}
</script>

<style lang="scss" scoped>
.vs-views {
  float: right;
  clear: both;
  margin-top: 12px;

  .with-vs,
  .without-vs {
    display: inline-block;
  }

  .with-vs {
    margin-right: 30px;
  }

  sup {
    margin-right: 5px;
    font-weight: 700;
    font-size: 10px;
  }

  .with-vs-text {
    color: $primary;
  }

  .without-vs-text {
    color: $error-2;
  }
}
</style>
